import React, { useContext, useEffect, useState } from 'react'
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import Popup from '../Common/Popup';

/**
 * The `SyndicationFilter` function is a React component that renders a dropdown menu for selecting
 * syndication options.
 * @returns a JSX element.
 */
function SyndicationFilter({ SyndicationOptions, setSyndicationOptions, customPathname, label = "Syndication", isPopupOpen, setIsPopupOpen }) {

    const { Syndications, refineSearchFilters } = useContext(PeFilterContext)
    const [internalPopupOpen, setInternalPopupOpen] = useState(false);
    const popupOpen = isPopupOpen !== undefined ? isPopupOpen : internalPopupOpen;
    const setPopupOpen = setIsPopupOpen !== undefined ? setIsPopupOpen : setInternalPopupOpen;

    useEffect(() => {
        const industryIds = refineSearchFilters[customPathname]?.syndication?.map(value => value.value) ?? [];
        setSyndicationOptions(Syndications?.map(industry => ({ ...industry, isChecked: industryIds.includes(industry.value) })))
    }, [Syndications, customPathname, refineSearchFilters, setSyndicationOptions])

    const handleSyndicationChange = (e) => {
        const value = e.target.value
        setSyndicationOptions(SyndicationOptions?.map(type => ({ ...type, isChecked: value === "" ? false : type.value === value })))
    };

    const selected = SyndicationOptions?.filter(option => option.isChecked)?.at(0)

    return (
        <div className="relative w-full md:inline-block">
            <button
                type="button"
                className="h-10 rounded-md px-4 py-1 text-gray-500 hover:bg-gray-100  text-sm shadow-md border border-gray-300 text-left flex items-center justify-between w-full md:w-[90%]"
                onClick={() => setPopupOpen(!popupOpen)}
            >
                <span className="truncate pr-2">{label}</span>
                <div className="flex items-center gap-2 flex-shrink-0">
                    {selected?.name && (
                        <span className="bg-white rounded-full px-2 py-0.5 text-xs font-medium border border-gray-400">
                            {selected.name}
                        </span>
                    )}
                    <span className={`transition-transform duration-200 text-xl font-semibold ${popupOpen ? 'rotate-[270deg]' : 'rotate-90'}`}>
                        ›
                    </span>
                </div>
            </button>

            {popupOpen && (
                <Popup onClose={() => setPopupOpen(false)}>
                    <div className="p-4">
                        {/* <label className="block text-sm font-medium text-gray-700 mb-2">
                            Select Syndication
                        </label> */}
                        <div className="space-y-2">
                            <div className="max-h-60 overflow-y-auto space-y-2 grid grid-cols-3">
                                <label className="flex items-center space-x-2 pt-1 hover:bg-gray-50 rounded cursor-pointer">
                                    <input
                                        type="radio"
                                        name="syndication"
                                        value=""
                                        checked={!selected}
                                        onChange={handleSyndicationChange}
                                        className="text-[#D9BD7F] focus:ring-[#D9BD7F]"
                                    />
                                    <span className="text-[13px] text-black font-semibold">All</span>
                                </label>
                                {/* <div className=''> */}
                                {SyndicationOptions && SyndicationOptions.length > 0 ? (
                                    SyndicationOptions.map((syndication, index) => (
                                        <label key={index} className="flex items-center space-x-2 hover:bg-gray-50 rounded cursor-pointer py-2">
                                            <input
                                                type="radio"
                                                name="syndication"
                                                value={syndication.value}
                                                checked={selected?.value === syndication.value}
                                                onChange={handleSyndicationChange}
                                                className="text-[#D9BD7F] focus:ring-[#D9BD7F]"
                                            />
                                            <span className="text-[13px] text-black font-semibold">{syndication.name}</span>
                                        </label>
                                    ))
                                ) : (
                                    <div className="text-sm text-gray-500 p-2">No results found!</div>
                                )}
                            {/* </div> */}
                            </div>
                        </div>
                    </div>
                </Popup>
            )}
        </div>
    )
}

export default SyndicationFilter